<!-- 样品图确认 -->
<template>
  <BaseFormItem
    :label="fields.label"
    :labelTips="fields.labelTips"
    isShowRequiredIcon
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <div slot="labelTipsContent" class="is_first_confirm__labelTipsContent">
      <p>
        需要确认：完成了插件料焊接的首块板子，我们将上传【样品图】到客户端，请您在收到【样品图】后4H内确认回复，如未回复我们将根据产品文件资料按IPC-610标准执行
      </p>
      <p>
        不需要确认：按IPC-610标准执行
      </p>
      <div v-if="smtOffiaccountInfo && smtOffiaccountInfo.url" class="is_first_confirm__labelTipsContent__offiaccount">
        <img :src="smtOffiaccountInfo.url" alt="华秋SMT公众号" />
        <ul>
          <li>绑定微信公众号，第一时间了解订单的最新进度</li>
          <li>生成时间：{{ smtOffiaccountInfo.createTime }}</li>
          <li>有效期至：{{ smtOffiaccountInfo.expireTime }}</li>
        </ul>
      </div>
    </div>

    <BaseRadioGroup v-model="val" @change="handleChange">
      <template v-for="item in fields.options">
        <BaseTipPopover
          v-if="isDevelopOrderDisabled && item.value == 1"
          :key="item.value"
          placement="top"
        >
          <el-radio-button
            slot="reference"
            :label="item.value"
            disabled
          >{{ item.label }}</el-radio-button>
          <p>研发型不支持</p>
          <p>如需选择请切换成标准型订单</p>
        </BaseTipPopover>
        <BaseTipPopover
          v-else
          :key="item.value"
          :content="item.tips"
          :disabled="!item.tips"
        >
          <el-radio-button
            slot="reference"
            :label="item.value"
          >{{ item.label }}</el-radio-button>
        </BaseTipPopover>
      </template>
    </BaseRadioGroup>

    <OffiaccountDailog ref="offiaccountDailogRef" />
  </BaseFormItem>
</template>

<script>
// SMT微信公众号弹框
import OffiaccountDailog from '../components/offiaccountDailog.vue'

import { mapGetters } from 'vuex'
import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    // 物料烘烤
    is_material_baking: {
      type: Number,
      default: 0
    },
    // 板面清洁
    is_layout_cleaning: {
      type: Number,
      default: 0
    },
    // 订单类型：0-标准型 1-研发型
    is_develop_order: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    OffiaccountDailog
  },
  data() {
    return {
      val: this.value,
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    // SMT微信公众号信息
    ...mapGetters('smtOffiaccount', [
      'smtOffiaccountInfo',
    ]),
    fields() {
      return getSMTFields('is_first_confirm')
    },
    // 是否显示未填写样式
    fillTips() {
      const val = this.val
      return !val && val !== 0 ? '请选择' : ''
    },
    // 研发型订单时禁用样品图确认选项
    isDevelopOrderDisabled() {
      return Number(this.is_develop_order) === 1
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    is_material_baking(newVal) {
      this.handleChangeVal(newVal)
    },
    is_layout_cleaning(newVal) {
      this.handleChangeVal(newVal)
    },
    isDevelopOrder(newVal) {
      // 切换为研发型订单时，如果选中的是需要，切换为不需要
      if (Number(newVal) === 1 && this.val === 1) {
        this.val = 0
        this.handleEmit()
      }
    }
  },
  created() {
    this.getSmtOffiaccount()
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
      this.isShowError(false)
    },
    handleChange() {
      this.handleEmit()
      // 样品图确认 == 需要
      if (this.val == 1) {
        this.handleoffiaccountDailog()
      }
    },
    // 需要 物料烘烤/板面清洁 时，样品图确认 选中 需要
    handleChangeVal(newVal) {
      // 研发型订单不支持样品图确认选择"需要"，因此不自动切换
      if (newVal === 1 && this.val !== 1 && !this.isDevelopOrderDisabled) {
        this.val = 1
        this.handleEmit()
      }
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    },
    // 显示SMT微信公众号弹框
    async handleoffiaccountDailog() {
      // 当公众号已绑定微信时，不需要再请求显示弹框
      const smtOffiaccountIsBindWx = (this.smtOffiaccountInfo || {}).isBindWx
      if (smtOffiaccountIsBindWx) return

      const { url, isBindWx } = await this.getSmtOffiaccount() || {}
      // 有二维码地址 && SMT微信公众号未绑定微信
      if (url && !isBindWx) {
        this.$refs.offiaccountDailogRef.open()
      }
    },
    // 获取SMT微信公众号绑定提示弹框
    async getSmtOffiaccount() {
      return await this.$store.dispatch('smtOffiaccount/getSmtOffiaccountInfo')
    },
  }
}
</script>

<style lang="scss" scoped>
.is_first_confirm__labelTipsContent {
  .is_first_confirm__labelTipsContent__offiaccount {
    display: flex;
    align-items: center;
    margin-top: 10px;
    >img {
      display: block;
      width: 100px;
    }
    >ul {
      margin-left: 10px;
      color: $--color-warning;
      >li + li {
        margin-top: 5px;
      }
    }
  }
}
</style>